import styled from 'styled-components';
import Palette from '../../common/Palette';

export const Container = styled.div`
  display: flex;
  align-content: start;
  gap: 1rem;
`;
export const IconWrapper = styled.span`
  width: 1.4rem;
  height: 1.4rem;
  flex-shrink: 0;
  margin-top: 0.2rem;
`;
export const Content = styled.div`
  color: ${Palette.TEXT_FONT_SECONDARY};
  font-size: 0.9rem;
`;
export const Header = styled.strong`
  display: block;
  margin: 0.25rem 0;
`;
export const Body = styled.p`
  margin-top: 0.2rem !important;
`;
